<template>
  <v-row no-gutters>
    <v-col cols="7" class="style-preview-draw-box d-flex justify-center align-center">
      <span class="draw-box-cross-top-left" />
      <span class="draw-box-cross-bottom-right" />
      <template v-if="isStyleValid">
        <layer-style-preview-icon :layer-type="geometryType" :layer-style="layerStyle" />
      </template>
    </v-col>
  </v-row>
</template>
<script>
import LayerStylePreviewIcon from '@/components/LayerStylePreviewIcon';
export default {
  name: 'StyleDialogStylePreview',
  components: { LayerStylePreviewIcon },
  props: {
    geometryType: {
      type: String,
      required: true,
    },
    isStyleValid: {
      type: Boolean,
      defalt: () => {
        return false;
      },
    },
    layerStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.style-preview-draw-box {
  height: 120px;
  border: 0.8px solid #898989;
  position: relative;
  z-index: 1;
}
.draw-box-cross-top-left {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 10px;
  left: calc(50% - 49px);
  border-right: 1px solid #898989;
  border-bottom: 1px solid #898989;
  z-index: 2;
}
.draw-box-cross-bottom-right {
  position: absolute;
  width: 50px;
  height: 50px;
  bottom: 9px;
  right: calc(50% - 50px);
  border-left: 1px solid #898989;
  border-top: 1px solid #898989;
  z-index: 2;
}
</style>
